import { render, staticRenderFns } from "./companysubsidydetail.vue?vue&type=template&id=7fbe5b3c&"
import script from "./companysubsidydetail.vue?vue&type=script&lang=js&"
export * from "./companysubsidydetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports